<app-navbar></app-navbar>

<div class="business-builder">
    <div class="left">
        <app-brochure-button
         fileName="Business Builder Workshop.pdf"
         label="Download Brochure"
         className="outline-btn">
      </app-brochure-button>

        <h1> BUSINESS BUILDER <br>
            WORKSHOP
        </h1>

        <h2> WHY CHOOSE <br> NexGen Executive Coaching Academy?</h2>

        <h5>CERTIFICATION:</h5>
        <p>Receive NexGen Executive Coaching Academy Business Builder Certification</p>

        <h5>EXPERT GUIDANCE</h5>
        <p> Learn from experienced Fortune 500 business professionals</p>

        <h5> PRACTICAL APPLICATION</h5>
        <p>Hands-on activities and real-world case studies</p>

        <h5>COMPREHENSIVE CURRICULUM</h5>
        <p>Advanced business methodologies and frameworks</p>

    </div>

    <div class="right">
        <div class="image">
            <img src="../../../assets/salesCertification/Screenshot 2025-07-23 010203.png" alt="">
        </div>
        <div class="contant">
            <div class="contant1">
                <h1> WORKSHOP OVERVIEW</h1>
                <p> This sophisticated one-day virtual workshop is meticulously
                    designed to empower aspiring executive coaches with the
                    essential skills and knowledge required to establish their own
                    coaching business. The curriculum encompasses a comprehensive
                    range of topics, from business formation to advanced marketing
                    strategies, client acquisition, and ethical considerations.</p>
            </div>
            <div class="contant2">
                <h5>nexgencoaches.com</h5>
                <h1> NexGen Executive Coaching Academy</h1>
                <p> Copyright NexGen Executive Coaching Academy, L.L.C. All rights reserved, not for duplication or
                    re-use</p>
            </div>
        </div>
    </div>
</div> 

<!-- <div style="width: 100%; height: 5px; background-color: black;"></div> -->


<div class="main2">
    <div class="left">
        <img src="../../../assets/builders/1.png" alt="">
    </div>


    <div class="middle">
        <p>Program Cost: $995</p>
        <h2>EXECUTIVE COACHING BUSINESS BUILDER WORKSHOP</h2>
        <p>TURN YOUR PASSION INTO PROFIT</p>

        <h5>WHAT'S INCLUDED:</h5>
        <ul>
            <li> Live Interactive Virtual Seminar</li>
            <li> Practical Application Activities</li>
            <li> One-month access to NexGen Executive Coaching Academy LMS</li>
            <li> Certification Exam</li>
            <li> Customized business canvas framework plan</li>
        </ul>

        
        <h5> REGISTRATION INFORMATION:</h5>
        <ul class="prerequisits">
            <li>  Workshop Format: Live Virtual Seminar</li>
            <li>  Duration: One full day (8 hours with breaks)</li>
            <li> Certificate: NexGen Executive Coaching Academy Business Builder Certification</li>
            <li>  Registration: Visit www.manninocoach.com</li>
        </ul>

        <p class="copyright"> Copyright NexGen Executive Coaching Academy, L.L.C.
            All rights reserved, not for duplication or re-use</p>
        <p class="bottom">nexgencoaches.com</p>
    </div>

<div class="right">
    <img src="../../../assets/builders/curiiculum-highlights.PNG" alt="Certification">
  </div>
    <!-- <div class="right">
        <div class="container">
            <div class="one">
                <div class="hours">
                    <h3>Hour1</h3>
                    <p>introduction to ececutive coaching as a bussiness</p>
                </div>

                <div class="hours" style="margin-top: 90px;">
                    <h3>Hour3</h3>
                    <p>Legal and financial considration</p>
                </div>

                <div class="hours" style="margin-top: 100px;">
                    <h3>Hour5</h3>
                    <p> Leveraging technology, AI and social media</p>
                </div>

                <div class="hours" style="margin-top: 100px;">
                    <h3>Hour7</h3>
                    <p> Practical applications and case studies</p>
                </div>
            </div>
            <img src="../../../assets/builders/2.png" alt="">
            <div class="two">
                <div class="hours" style="margin-top: 60px;">
                    <h3>Hour2</h3>
                    <p>Builing a bussiness plane</p>
                </div>

                <div class="hours" style="margin-top: 90px;">
                    <h3>Hour4</h3>
                    <p> Developing your brand and niche</p>
                </div>

                <div class="hours" style="margin-top: 90px;">
                    <h3>Hour6</h3>
                    <p>Client acquisition and relationship management</p>
                </div>

                <div class="hours" style="margin-top: 9 0px;">
                    <h3>Hour8</h3>
                    <p> Ethical and legal considerations</p>
                </div>
            </div>
        </div>
    </div> -->
</div>

<app-footer></app-footer>